module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.anySiblingNodeHasAssistanceBool()) ? _c('tr', {
    staticClass: "orgchart-secretary lines"
  }, [_c('td', {
    attrs: {
      "colspan": 100
    }
  }, [(typeof _vm.data.children !== 'undefined' || (_vm.data.codassis !== '' && _vm.data.assistActive)) ? [_c('div', {
    staticClass: "downLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "downLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "downLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "downLine test-secretary"
  }, [(_vm.data.codassis !== '' && _vm.data.assistActive) ? [_c('div', {
    staticClass: "sideLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "node",
    attrs: {
      "draggable": "true"
    }
  }, [(_vm.data.imgassispath !== '') ? _c('div', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": 'data:image/jpeg;base64,' + _vm.data.imgassispath
    }
  })]) : _c('div', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.receivedOrgBodyDetail(_vm.data)
      }
    }
  }, [_vm._v(_vm._s(_vm.data.desc_assis))])])])] : _vm._e()], 2), _vm._v(" "), (typeof _vm.data.children !== 'undefined') ? [(_vm.filterActive(_vm.data.children).length > 0) ? [_c('div', {
    staticClass: "downLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "downLine"
  }), _vm._v(" "), _c('div', {
    staticClass: "downLine"
  })] : _vm._e()] : _vm._e()] : _vm._e()], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-256d1400!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orgchart/orgchartSecretary.vue
// module id = 3635
// module chunks = 1